import { render, staticRenderFns } from "./DetallesRecibo.vue?vue&type=template&id=57ed7d56"
import script from "./DetallesRecibo.vue?vue&type=script&lang=js"
export * from "./DetallesRecibo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports